import * as React from 'react';
import { ToastList } from '../widgets';
export var BaseLayout = function (props) { return (React.createElement("div", null,
    React.createElement("nav", { className: "container-sm my-3" },
        React.createElement("h1", null,
            React.createElement("span", { style: { color: '#cc3366', fontWeight: 'bold' } }, "Dokumente"),
            React.createElement("span", { style: { fontSize: '50%' } }, ".nrw"))),
    React.createElement("main", null, props.children),
    React.createElement(ToastList, null))); };
